/* Artist block — category tabs + product slider.
 *
 * Same cells drive two mechanics by breakpoint:
 *   • Desktop (≥500px): paginated 4-per-page. Non-page cells are display:none;
 *     dots + prev/next arrows change the page; a slide-in class animates it.
 *   • Mobile (<500px): native horizontal snap carousel (2 per view). All the
 *     tab's cells are shown; dots (one per card) track the leftmost visible one
 *     via the scroll position and scroll to a card on click.
 *
 * Category tabs filter cells by data-type (set on the card <article>). Each tab
 * paginates its own matches, so filtering never runs short. Every homepage
 * artist block is wired independently. No-op if a block has no track/cells.
 */
(function () {
  var PER = 4; // desktop cards per page
  var mq = window.matchMedia('(max-width: 499px)');

  function initBlock(block) {
    var tabs = Array.prototype.slice.call(block.querySelectorAll('[data-artist-tab]'));
    var viewport = block.querySelector('[data-ab-viewport]');
    var track = block.querySelector('[data-ab-track]');
    var cells = Array.prototype.slice.call(block.querySelectorAll('[data-ab-cell]'));
    var pager = block.querySelector('[data-ab-pager]');
    var dotsWrap = block.querySelector('[data-ab-dots]');
    var prevBtn = block.querySelector('[data-ab-prev]');
    var nextBtn = block.querySelector('[data-ab-next]');
    if (!viewport || !track || !cells.length || !pager || !dotsWrap) return;

    var activeType = '';
    var page = 0;
    var MPV = 2; // mobile cards per view (CSS: .artist-block__cell = calc(50% - 6rem))

    function filtered() {
      var list = cells.filter(function (c) {
        if (!activeType) return true;
        if (activeType === 'signed') return c.getAttribute('data-signed') === '1';
        if (activeType === 'new') return c.getAttribute('data-new') === '1';
        return c.getAttribute('data-type') === activeType;
      });
      // Format tabs (vinyl/cd/cassette) show the list reversed, so switching between
      // "New" and a format reads as a real change even when the catalogue is all one
      // format + one date. New keeps the natural order. (Owner request.)
      if (activeType === 'vinyl' || activeType === 'cd' || activeType === 'cassette') {
        list = list.slice().reverse();
      }
      return list;
    }

    function buildDots(count, activeIndex, onClick) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'artist-block__dot' + (idx === activeIndex ? ' is-active' : '');
          b.setAttribute('aria-label', 'Page ' + (idx + 1));
          b.addEventListener('click', function () { onClick(idx); });
          dotsWrap.appendChild(b);
        })(i);
      }
    }

    function markDot(activeIndex) {
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === activeIndex);
    }

    function applyDesktop(dir) {
      var vis = filtered();
      var pages = Math.max(1, Math.ceil(vis.length / PER));
      if (page >= pages) page = 0;
      cells.forEach(function (c) { c.style.display = 'none'; });
      // Explicit 'flex' (not '') so it overrides the pre-JS nth-child hide rule.
      vis.forEach(function (c, i) { if (Math.floor(i / PER) === page) c.style.display = 'flex'; });
      if (dir) {
        track.classList.remove('is-slide-right', 'is-slide-left');
        void track.offsetWidth; // reflow so the animation re-fires
        track.classList.add(dir === 'left' ? 'is-slide-left' : 'is-slide-right');
      }
      if (pages > 1) {
        pager.hidden = false;
        buildDots(pages, page, function (idx) {
          var d = idx > page ? 'right' : 'left';
          page = idx;
          applyDesktop(d);
        });
      } else {
        pager.hidden = true;
        dotsWrap.innerHTML = '';
      }
    }

    function applyMobile() {
      var vis = filtered();
      // Show exactly the filtered cells. filtered() handles the 'signed' tab
      // (keyed on data-signed, not data-type) — the old data-type check hid every
      // signed cell while the dots still counted them.
      cells.forEach(function (c) { c.style.display = 'none'; });
      vis.forEach(function (c) { c.style.display = 'flex'; });
      track.classList.remove('is-slide-right', 'is-slide-left');
      viewport.scrollLeft = 0;
      // Dots track PAGES (2 cards per screen), not individual cards — otherwise
      // the count is doubled and a trailing dot points past the last card.
      var pages = Math.ceil(vis.length / MPV);
      if (pages > 1) {
        pager.hidden = false;
        buildDots(pages, 0, function (idx) {
          var target = vis[idx * MPV];
          if (!target) return;
          var delta = target.getBoundingClientRect().left - viewport.getBoundingClientRect().left;
          viewport.scrollTo({ left: viewport.scrollLeft + delta, behavior: 'smooth' });
        });
      } else {
        pager.hidden = true;
        dotsWrap.innerHTML = '';
      }
    }

    function apply(dir) {
      if (mq.matches) applyMobile(); else applyDesktop(dir);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeType = tab.getAttribute('data-artist-tab') || '';
        page = 0;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-artist-tab') === activeType;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        apply('right');
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (mq.matches) return;
      var np = Math.max(0, page - 1);
      if (np !== page) { page = np; applyDesktop('left'); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (mq.matches) return;
      var pages = Math.max(1, Math.ceil(filtered().length / PER));
      var np = Math.min(pages - 1, page + 1);
      if (np !== page) { page = np; applyDesktop('right'); }
    });

    // Mobile: reflect scroll position in the active dot.
    var raf = null;
    viewport.addEventListener('scroll', function () {
      if (!mq.matches || raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var vis = filtered();
        var pages = Math.ceil(vis.length / MPV);
        if (pages < 2) return;
        // Active page = floor(leftmost-visible-card index / MPV). Nearest card to
        // the viewport's left edge (rect-based → independent of gap quirks).
        var vpLeft = viewport.getBoundingClientRect().left;
        var idx = 0, best = Infinity;
        for (var i = 0; i < vis.length; i++) {
          var d = Math.abs(vis[i].getBoundingClientRect().left - vpLeft);
          if (d < best) { best = d; idx = i; }
        }
        var pageIdx = Math.floor(idx / MPV);
        // At scroll end, force the LAST page active (the final card may sit
        // mid-page, so it would otherwise never highlight the last dot).
        if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2) {
          pageIdx = pages - 1;
        }
        if (pageIdx < 0) pageIdx = 0;
        if (pageIdx > pages - 1) pageIdx = pages - 1;
        markDot(pageIdx);
      });
    });

    // Switch mechanic when crossing the breakpoint.
    var onMq = function () { page = 0; apply(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    // Default the active filter to the first tab — works whether or not an "All"
    // (empty-value) tab exists (vinyl-store mode drops "All").
    if (tabs.length) {
      activeType = tabs[0].getAttribute('data-artist-tab') || '';
      tabs.forEach(function (t, i) {
        var on = i === 0;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    apply();
  }

  function syncEmptyBanners() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-artist-block]'));
    blocks.forEach(function (block, index) {
      if (!block.hasAttribute('data-ab-empty')) return;
      var referenceBlock = blocks.slice(index + 1).find(function (candidate) {
        return !candidate.hasAttribute('data-ab-empty') && candidate.querySelector('[data-ab-cell]');
      });
      if (!referenceBlock) {
        referenceBlock = blocks.slice(0, index).reverse().find(function (candidate) {
          return !candidate.hasAttribute('data-ab-empty') && candidate.querySelector('[data-ab-cell]');
        });
      }
      var reference = referenceBlock && referenceBlock.querySelector('.artist-block__banner');
      if (!reference) return;
      function syncHeight() {
        var height = reference.getBoundingClientRect().height;
        if (height > 0) block.style.setProperty('--ab-empty-banner-height', height + 'px');
      }
      syncHeight();
      if (window.ResizeObserver) {
        new ResizeObserver(syncHeight).observe(reference);
      } else {
        window.addEventListener('resize', syncHeight);
      }
    });
  }

  document.querySelectorAll('[data-artist-block]').forEach(initBlock);
  syncEmptyBanners();
})();
